// MENU HANDLER

document.querySelector(".js-hamburger").addEventListener("click", function (e) {
    e.preventDefault();
    var menuEl = document.querySelector(".js-menu");
    if (menuEl.classList.contains("c-header__menu--active")) {
        document.body.style.position = "relative";
        this.classList.remove("c-header__hamburger--active");
        menuEl.classList.remove("c-header__menu--active");
    } else {
        this.classList.add("c-header__hamburger--active");
        menuEl.classList.add("c-header__menu--active");
        document.body.style.position = "fixed";
    }
});

// FAQ

let toggles = document.getElementsByClassName("c-faq__list-link");
let contentDiv = document.getElementsByClassName("c-faq__list-content");

for (let i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener("click", () => {
        if (parseInt(contentDiv[i].style.height) != contentDiv[i].scrollHeight) {
            contentDiv[i].style.height = contentDiv[i].scrollHeight + "px";
            toggles[i].classList.add("c-faq__list-link--active");
        } else {
            contentDiv[i].style.height = "0px";
            toggles[i].classList.remove("c-faq__list-link--active");
        }

        for (let j = 0; j < contentDiv.length; j++) {
            if (j !== i) {
                contentDiv[j].style.height = "0px";
                toggles[j].classList.remove("c-faq__list-link--active");
            }
        }
    });
}

$(document).ready(function () {
// SLOW ANCHOR LINK
    $(".anchor-link").click(function (e) {
        e.preventDefault();
        var jumpId = $(this).attr("href");
        $("body, html").animate({scrollTop: $(jumpId).offset().top}, "slow");
    });

// HP CAROUSEL

    if ($(".js-carousel-content").length) {
        $(".js-carousel-content").slick({
            speed: 200,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            adaptiveHeight: true,
            asNavFor: ".js-carousel-nav",
            swipe: true,
            pauseOnHover: false,
        });

        $(".js-carousel-nav").slick({
            speed: 200,
            slidesToShow: 3,
            asNavFor: ".js-carousel-content",
            dots: false,
            adaptiveHeight: true,
            centerMode: false,
            focusOnSelect: true,
            infinite: false,
            variableWidth: true,
            swipe: true,
            arrows: false,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
        setTimeout(function () {
            $(".js-carousel").addClass("c-carousel--active");
        }, 100);
    }
});
